<app-common-bulk-select-performance-employee-dialog
    #selectEmployees
    headerText="performance.bulk-review.selectReviewees.title"
    label="save"
    [additionalQueryFilters]="[addMoreIncludesToBulkSelectDialogEmployeeQuery]"
>
</app-common-bulk-select-performance-employee-dialog>

<form #form="ngForm">
    <div class="app-grid">
        <app-segment-header title="performance.bulk-review.selectReviewees.title"></app-segment-header>

        <div *ngIf="computedRows?.length > 0">
            <div class="flex align-center space-between middle margin-y-3">
                <app-search #searchBar placeholder="search" (onSearch)="onSearch($event)"></app-search>
            </div>

            <app-simple-table
                *ngIf="rows?.length > 0"
                [columns]="columns"
                [rows]="rows"
                [fixedHeight]="true"
                [showInlineButton]="true"
                [inlineButtonText]="'remove'"
                (inlineButtonClicked)="removeEmployee($event)"
                [trackByRow]="trackByRow"
            >
            </app-simple-table>

            <h3 *ngIf="!rows?.length" class="centered">
                {{ 'performance.bulk-review.selectReviewees.noResults' | translate }}
            </h3>
        </div>

        <ui-button (click)="showBulkSelectDialog()" type="primary" class="margin-top-3">
            {{ 'performance.bulk-review.selectReviewees.addOrRemoveReviewees' | translate }}
        </ui-button>
    </div>
</form>
